<template>
  <div id="softwareSelect" class="db-space-select">
    <span class="mg-rt-sm">适配软件</span>
    <el-select
      v-model="softwareItem"
      class="software-select"
      value-key="softwareCode"
      placeholder="软件不限"
      @change="softwareChange"
      style="width: 170px;font-size: 12px;"
      :disabled="isAvailable"
    >
      <el-option
        v-for="item in softwareList"
        :key="item.softwareCode"
        :label="item.softwareName"
        :value="item"
      />
    </el-select>
    <!-- 软件版本 -->
    <el-select
      v-model="versionItem"
      class="version-select"
      value-key="softwareVersion"
      placeholder="不限"
      clearable
      @change="versionChange"
      style="width: 120px;"
      :disabled="isAvailable"
    >
      <el-option
        v-for="(item, index) in versionList"
        :key="index"
        :label="item.displayVersion"
        :value="item"
      />
    </el-select>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SoftwareSelect',
  props: {
    // 资源类型
    resourceType: {
      type: String,
    },
    // 子模块code
    subModule: {
      type: String,
    },
    // 平台code
    platform: {
      type: String,
    },
    // 软件版本是否必选
    isVersionRequire: {
      type: Boolean,
      default: true
    },
    // 软件\版本是否可用
    isAvailable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const flag1 = ['COMPONENT', 'MODULE'].includes(this.resourceType)
    const flag2 = ['COMPONENT'].includes(this.resourceType)
    const flag3 = ['COMPONENT', 'SCHEME'].includes(this.resourceType)
    return {
      softwareList: [],
      NOVA_DESIGN_List: [
        { softwareName: '广联达数维建筑设计', softwareCode: 'AppGarch', isShow: flag1 },
        { softwareName: '广联达数维结构设计', softwareCode: 'AppGstr', isShow: flag1 },
        { softwareName: '广联达数维机电设计', softwareCode: 'AppGmep', isShow: flag1 },
        { softwareName: '广联达数维道路设计', softwareCode: 'AppGroad', isShow: flag2 },
        { softwareName: '广联达数维桥梁设计', softwareCode: 'AppGbr', isShow: flag3 },
      ],
      REVIT_List: [
        { softwareName: 'Revit', softwareCode: 'revit' },
      ],
      // 软件所支持的语言权限列表
      softwarePermissionLanguages: [],
      // 字符串，将code以,分隔，便于传参
      softwarePermissionLanguageCodes: null,
      versionList: [],
      softwareItem: {},
      versionItem: null,
      spaceId: this.$route.params.spaceId,
      firstSelect: false
    }
  },
  computed: {
    ...mapGetters({
      clientTypeSoftwareVersion: 'softwareVersion',
      clientTypeSoftwareCode: 'softwareCode',
      clientType: 'platform',
    }),
  },
  watch: {
    subModule: {
      handler() {
        // 获取空间ID
        this.spaceId = this.$route.params.spaceId
        this.getSoftwareList()
      },
      immediate: true
    },
  },
  mounted() {
    this.firstSelect = true
  },
  methods: {
    ...mapMutations({
      // setShowContent: 'softwareUpdate/setShowContent',
    }),
    ...mapActions({
      // loadVersionOperations: 'softwareUpdate/loadVersionOperations',
    }),
    // 获取软件列表
    async getSoftwareList() {
      if (['V_Component_REVIT'].includes(this.subModule)) {
        this.softwareList = this.REVIT_List
        this.softwareItem = this.softwareList[0]
      } else {
        this.softwareList = this.NOVA_DESIGN_List.filter((item) => item.isShow)
        if (this.clientTypeSoftwareCode && this.clientType === 'g') {
          const softwareItem = this.softwareList.find((f) => f.softwareCode === this.clientTypeSoftwareCode)
          this.softwareItem = softwareItem || this.softwareList[0]
        } else {
          this.softwareItem = this.softwareList[0]
        }
      }
      await this.softwareChange()
    },
    // 获取软件可筛选的版本列表
    async getSoftwareVersionList(softwareCode) {
      const data = await this.$api.software.softwareVersionList({
        resource_type: this.resourceType,
        software_code: softwareCode,
        space_id: this.spaceId,
        software_platform: this.platform
      })
      this.versionList = data || []
      if (this.firstSelect) {
        this.versionItem = null
        this.firstSelect = false
      } else {
        const oldSoftwareVersion = this.versionItem ? this.versionItem.softwareVersion : ''
        const index = this.versionList.findIndex((v) => { return v.softwareVersion === oldSoftwareVersion })
        this.versionItem = index >= 0
          ? this.versionList[index]
          : this.isVersionRequire && data && data.length
            ? data[0]
            : null
      }
    },
    async softwareChange() {
      const softwareCode = this.softwareItem ? this.softwareItem.softwareCode : ''
      if (softwareCode) {
        await this.getSoftwareVersionList(softwareCode)
        this.emitChangeEvent({ changeType: 'software' })
      }
    },
    async versionChange() {
      const softwareVersion = this.versionItem ? this.versionItem.softwareVersion : ''
      if (this.isVersionRequire) {
        if (softwareVersion) {
          this.emitChangeEvent({ changeType: 'version' })
        } else {
          this.emitChangeEvent({ changeType: 'version' })
        }
      } else {
        this.emitChangeEvent({ changeType: 'version' })
      }
    },
    emitChangeEvent(obj) {
      const isNewestVersion = !this.versionList.length || (this.versionItem && this.versionItem.softwareVersion === this.versionList[0].softwareVersion)
      const payload = {
        ...obj,
        software: this.softwareItem || {},
        version: this.versionItem || {},
        language: {},
        isNewestVersion,
      }
      this.$emit('change', payload)
    },
    resetSelectedVersion() {
      this.versionItem = null
    }
  },
}
</script>

<style lang="less" scoped>
  .db-space-select{
    display: inline-block;
    margin-bottom: 10px;
  }
  .software-select{
    margin-right: 8px;
    width: 164px;
  }
  .version-select {
    margin-right: 14px;
    width: 110px;
  }
  .language-select{
    margin-right: 10px;
    width: 100px;
  }
</style>
<style>
.software-select .el-input {
  font-size: 12px !important;
}
.version-select .el-input {
  font-size: 12px !important;
}
</style>
